import { FC } from 'react';
import { useGetCardDetailAndBalance } from '@/queries/card';
import BottomSheet from '@/components/BottomSheet';
import CardRestoreStep from '@/modules/home/pages/index/components/CardComponents/components/IssueSteps/CardRestoreStep';

const RestoreMofidCardBottomsheet: FC = () => {
  const { refetch } = useGetCardDetailAndBalance(
    {
      refetchOnWindowFocus: false,
    },
    { shouldEnableAutoCall: true }
  );
  return <CardRestoreStep refetchCardStatus={refetch} />;
};

export const openRestoreMofidCardBottomsheet = () => {
  return BottomSheet.open({
    children: <RestoreMofidCardBottomsheet />,
  });
};
